// Profession descriptions for onboarding.
// Only English keys provided — add translations for other locales as needed.
export const professionDescriptions = {
    en: {
        professionDesc: {
            nail_master: 'Nail technician specializing in manicure, pedicure, and nail art',
            hairdresser: 'Hair stylist offering cuts, coloring, and treatments',
            barber: 'Barber specializing in men\'s grooming and haircuts',
            makeup_artist: 'Makeup artist for events, weddings, and photo shoots',
            brow_lash: 'Brow and lash specialist — shaping, extensions, lamination',
            cosmetologist: 'Skincare professional offering facials and cosmetic procedures',
            massage_therapist: 'Licensed massage therapist — therapeutic and relaxation',
            permanent_makeup: 'Permanent makeup artist — eyebrows, lips, eyeliner',
            hair_extensions: 'Hair extension specialist — application and correction',
            laser_hair_removal: 'Laser hair removal specialist',
            personal_trainer: 'Certified personal fitness trainer',
            online_fitness: 'Online fitness coach and trainer',
            yoga_instructor: 'Yoga instructor for private sessions',
            pilates_instructor: 'Pilates instructor and body conditioning specialist',
            psychologist: 'Licensed psychologist — counseling and therapy',
            psychotherapist: 'Psychotherapist in private practice',
            speech_therapist: 'Speech-language pathologist',
            rehabilitation: 'Rehabilitation specialist — recovery and physical therapy',
            osteopath: 'Osteopath — manual therapy and holistic treatment',
            physiotherapist: 'Physiotherapist — movement and rehabilitation',
            coach: 'Life or business coach — personal development',
            nutritionist: 'Nutritionist — diet planning and health consulting',
            private_lawyer: 'Private practice lawyer — consultations and documents',
            attorney: 'Attorney — legal representation and advocacy',
            tax_consultant: 'Tax consultant — planning and compliance',
            accountant: 'Accountant — bookkeeping and financial reporting',
            financial_advisor: 'Financial advisor — investments and planning',
            mortgage_advisor: 'Mortgage advisor — loans and property finance',
            photographer: 'Professional photographer',
            videographer: 'Videographer — filming, editing, production',
            event_host: 'Event host and MC',
            dj: 'DJ — music and entertainment for events',
            tutor: 'Private tutor — academic subjects',
            language_teacher: 'Language teacher — foreign language instruction',
            music_teacher: 'Music teacher — instrument and vocal lessons',
            child_psychologist: 'Child psychologist — development and behavior',
            school_prep: 'Early education specialist — school readiness',
            groomer: 'Pet groomer — bathing, styling, and care',
            dogsitter: 'Dog sitter — pet care and boarding',
            dog_walker: 'Dog walker — scheduled walks and exercise',
            dog_trainer: 'Dog trainer — obedience and behavior',
        },
    },

    de: {
        professionDesc: {
            nail_master: 'Nageldesigner/in für Maniküre, Pediküre und Nail Art',
            hairdresser: 'Friseur/in für Schnitte, Coloration und Behandlungen',
            barber: 'Barbier für Herrenhaarschnitte und Bartpflege',
            makeup_artist: 'Make-up-Artist für Events, Hochzeiten und Fotoshootings',
            brow_lash: 'Spezialist/in für Augenbrauen und Wimpern — Formen, Extensions, Lifting',
            cosmetologist: 'Kosmetiker/in für Gesichtsbehandlungen und kosmetische Verfahren',
            massage_therapist: 'Zertifizierte/r Masseur/in für Therapie und Entspannung',
            permanent_makeup: 'Permanent-Make-up-Artist für Augenbrauen, Lippen und Lidstrich',
            hair_extensions: 'Spezialist/in für Haarverlängerung — Einarbeitung und Korrektur',
            laser_hair_removal: 'Spezialist/in für Laser-Haarentfernung',
            personal_trainer: 'Zertifizierte/r Personal Trainer/in',
            online_fitness: 'Online-Fitnesscoach',
            yoga_instructor: 'Yogalehrer/in für Einzelstunden',
            pilates_instructor: 'Pilatestrainer/in für Körpertraining',
            psychologist: 'Psychologe/Psychologin — Beratung und Therapie',
            psychotherapist: 'Psychotherapeut/in in eigener Praxis',
            speech_therapist: 'Logopäde/Logopädin',
            rehabilitation: 'Rehabilitationsspezialist/in — Genesung und Physiotherapie',
            osteopath: 'Osteopath/in — manuelle und ganzheitliche Therapie',
            physiotherapist: 'Physiotherapeut/in — Bewegung und Rehabilitation',
            coach: 'Life- oder Business-Coach für persönliche Entwicklung',
            nutritionist: 'Ernährungsberater/in — Ernährungsplanung und Gesundheitsberatung',
            private_lawyer: 'Rechtsanwalt/Rechtsanwältin in eigener Praxis',
            attorney: 'Anwalt/Anwältin — rechtliche Vertretung',
            tax_consultant: 'Steuerberater/in — Planung und Compliance',
            accountant: 'Buchhalter/in — Buchführung und Finanzberichte',
            financial_advisor: 'Finanzberater/in — Investitionen und Planung',
            mortgage_advisor: 'Hypothekenberater/in — Immobilienfinanzierung',
            photographer: 'Berufsfotograf/in',
            videographer: 'Videograf/in — Aufnahme, Schnitt und Produktion',
            event_host: 'Moderator/in und Event-Host',
            dj: 'DJ — Musik und Unterhaltung für Events',
            tutor: 'Nachhilfelehrer/in — Schulfächer',
            language_teacher: 'Sprachlehrer/in — Fremdsprachenunterricht',
            music_teacher: 'Musiklehrer/in — Instrumental- und Gesangsunterricht',
            child_psychologist: 'Kinderpsychologe/Kinderpsychologin — Entwicklung und Verhalten',
            school_prep: 'Fachkraft für Vorschule — Schulvorbereitung',
            groomer: 'Tierfriseur/in (Groomer) — Pflege und Styling',
            dogsitter: 'Hundesitter/in — Betreuung und Unterbringung',
            dog_walker: 'Gassi-Service — regelmäßige Spaziergänge',
            dog_trainer: 'Hundetrainer/in — Erziehung und Verhalten',
        },
    },

    ru: {
        professionDesc: {
            nail_master: 'Мастер ногтевого сервиса — маникюр, педикюр, дизайн',
            hairdresser: 'Парикмахер — стрижки, окрашивание и уход',
            barber: 'Барбер — мужские стрижки и уход за бородой',
            makeup_artist: 'Визажист для мероприятий, свадеб и фотосессий',
            brow_lash: 'Бровист и лешмейкер — коррекция, наращивание, ламинирование',
            cosmetologist: 'Косметолог — уходовые и косметические процедуры',
            massage_therapist: 'Массажист — лечебный и расслабляющий массаж',
            permanent_makeup: 'Мастер перманентного макияжа — брови, губы, стрелки',
            hair_extensions: 'Мастер по наращиванию волос — установка и коррекция',
            laser_hair_removal: 'Специалист по лазерной эпиляции',
            personal_trainer: 'Персональный фитнес-тренер',
            online_fitness: 'Онлайн-фитнес тренер',
            yoga_instructor: 'Инструктор по йоге для индивидуальных занятий',
            pilates_instructor: 'Инструктор по пилатесу и укреплению тела',
            psychologist: 'Психолог — консультации и терапия',
            psychotherapist: 'Психотерапевт частной практики',
            speech_therapist: 'Логопед',
            rehabilitation: 'Специалист по реабилитации — восстановление и ЛФК',
            osteopath: 'Остеопат — мануальная и комплексная терапия',
            physiotherapist: 'Физиотерапевт — движение и реабилитация',
            coach: 'Лайф- или бизнес-коуч — личное развитие',
            nutritionist: 'Нутрициолог — питание и консультации по здоровью',
            private_lawyer: 'Частный юрист — консультации и документы',
            attorney: 'Адвокат — представительство и защита',
            tax_consultant: 'Налоговый консультант',
            accountant: 'Бухгалтер — учёт и финансовая отчётность',
            financial_advisor: 'Финансовый консультант — инвестиции и планирование',
            mortgage_advisor: 'Ипотечный консультант — кредиты и недвижимость',
            photographer: 'Профессиональный фотограф',
            videographer: 'Видеограф — съёмка и монтаж',
            event_host: 'Ведущий мероприятий',
            dj: 'Диджей — музыка и развлечения на мероприятиях',
            tutor: 'Репетитор — школьные предметы',
            language_teacher: 'Преподаватель языков — иностранные языки',
            music_teacher: 'Преподаватель музыки — инструменты и вокал',
            child_psychologist: 'Детский психолог — развитие и поведение',
            school_prep: 'Специалист по подготовке к школе',
            groomer: 'Грумер — уход и стрижка животных',
            dogsitter: 'Догситтер — уход и передержка',
            dog_walker: 'Выгульщик собак — прогулки по расписанию',
            dog_trainer: 'Кинолог — дрессировка и коррекция поведения',
        },
    },

    es: {
        professionDesc: {
            nail_master: 'Técnico/a de uñas especializado/a en manicura, pedicura y nail art',
            hairdresser: 'Peluquero/a que ofrece cortes, coloración y tratamientos',
            barber: 'Barbero especializado en cortes masculinos y arreglo de barba',
            makeup_artist: 'Maquillador/a para eventos, bodas y sesiones de fotos',
            brow_lash: 'Especialista en cejas y pestañas: diseño, extensiones y laminado',
            cosmetologist: 'Profesional de estética y cuidado de la piel: faciales y procedimientos косметológicos',
            massage_therapist: 'Masajista titulado/a: masaje terapéutico y relajante',
            permanent_makeup: 'Especialista en maquillaje permanente: cejas, labios y delineado',
            hair_extensions: 'Especialista en extensiones de cabello: aplicación y corrección',
            laser_hair_removal: 'Especialista en depilación láser',
            personal_trainer: 'Entrenador/a personal certificado/a',
            online_fitness: 'Coach de fitness online',
            yoga_instructor: 'Instructor/a de yoga para sesiones privadas',
            pilates_instructor: 'Instructor/a de pilates y acondicionamiento corporal',
            psychologist: 'Psicólogo/a colegiado/a: orientación y terapia',
            psychotherapist: 'Psicoterapeuta en consulta privada',
            speech_therapist: 'Logopeda / terapeuta del lenguaje',
            rehabilitation: 'Especialista en rehabilitación: recuperación y terapia física',
            osteopath: 'Osteópata: terapia manual y enfoque integral',
            physiotherapist: 'Fisioterapeuta: movimiento y rehabilitación',
            coach: 'Coach personal o de negocios: desarrollo personal',
            nutritionist: 'Nutricionista: planificación de dieta y asesoramiento de salud',
            private_lawyer: 'Abogado/a en práctica privada: consultas y documentos',
            attorney: 'Abogado/a: representación y defensa legal',
            tax_consultant: 'Asesor/a fiscal: planificación y cumplimiento',
            accountant: 'Contable: contabilidad y reportes financieros',
            financial_advisor: 'Asesor/a financiero/a: inversiones y planificación',
            mortgage_advisor: 'Asesor/a hipotecario/a: financiación de vivienda',
            photographer: 'Fotógrafo/a profesional',
            videographer: 'Videógrafo/a: grabación, edición y producción',
            event_host: 'Presentador/a y maestro/a de ceremonias',
            dj: 'DJ: música y entretenimiento para eventos',
            tutor: 'Tutor/a particular: materias académicas',
            language_teacher: 'Profesor/a de idiomas: enseñanza de lenguas extranjeras',
            music_teacher: 'Profesor/a de música: instrumentos y canto',
            child_psychologist: 'Psicólogo/a infantil: desarrollo y conducta',
            school_prep: 'Especialista en educación infantil: preparación escolar',
            groomer: 'Peluquero/a canino/a: baño, arreglo y cuidados',
            dogsitter: 'Cuidador/a de perros: cuidado y alojamiento',
            dog_walker: 'Paseador/a de perros: paseos programados y ejercicio',
            dog_trainer: 'Adiestrador/a canino: obediencia y comportamiento',
        },
    },

    fr: {
        professionDesc: {
            nail_master: 'Prothésiste ongulaire spécialisée en manucure, pédicure et nail art',
            hairdresser: 'Coiffeur/coiffeuse: coupes, coloration et soins',
            barber: 'Barbier spécialisé dans la coiffure homme et l\'entretien de la barbe',
            makeup_artist: 'Maquilleur/maquilleuse pour événements, mariages et séances photo',
            brow_lash: 'Spécialiste sourcils et cils: restructuration, extensions, lamination',
            cosmetologist: 'Esthéticien/ne: soins du visage et procédures esthétiques',
            massage_therapist: 'Masseur/masseuse certifié(e): massages thérapeutiques et relaxants',
            permanent_makeup: 'Spécialiste maquillage permanent: sourcils, lèvres, eye-liner',
            hair_extensions: 'Spécialiste extensions capillaires: pose et correction',
            laser_hair_removal: 'Spécialiste épilation laser',
            personal_trainer: 'Coach sportif personnel certifié',
            online_fitness: 'Coach fitness en ligne',
            yoga_instructor: 'Professeur(e) de yoga pour séances privées',
            pilates_instructor: 'Instructeur/instructrice Pilates et renforcement musculaire',
            psychologist: 'Psychologue diplômé(e): accompagnement et thérapie',
            psychotherapist: 'Psychothérapeute en cabinet',
            speech_therapist: 'Orthophoniste',
            rehabilitation: 'Spécialiste en rééducation: récupération et thérapie physique',
            osteopath: 'Ostéopathe: thérapie manuelle et approche globale',
            physiotherapist: 'Kinésithérapeute: mouvement et rééducation',
            coach: 'Coach de vie ou business: développement personnel',
            nutritionist: 'Nutritionniste: plan alimentaire et conseils santé',
            private_lawyer: 'Avocat(e) en cabinet privé: consultations et documents',
            attorney: 'Avocat(e): représentation et défense',
            tax_consultant: 'Conseiller/ère fiscal(e): optimisation et conformité',
            accountant: 'Comptable: tenue des comptes et reporting financier',
            financial_advisor: 'Conseiller/ère financier/ère: investissements et planification',
            mortgage_advisor: 'Conseiller/ère en crédit immobilier',
            photographer: 'Photographe professionnel(le)',
            videographer: 'Vidéaste: tournage, montage, production',
            event_host: 'Animateur/animatrice d\'événements',
            dj: 'DJ: musique et animation pour événements',
            tutor: 'Professeur(e) particulier/ère: matières scolaires',
            language_teacher: 'Professeur(e) de langues: langues étrangères',
            music_teacher: 'Professeur(e) de musique: instruments et chant',
            child_psychologist: 'Psychologue pour enfants: développement et comportement',
            school_prep: 'Spécialiste petite enfance: préparation à l\'école',
            groomer: 'Toiletteur/toiletteuse: bain, coupe et soins',
            dogsitter: 'Dogsitter: garde et hébergement',
            dog_walker: 'Promeneur/promeneuse de chiens',
            dog_trainer: 'Éducateur/trice canin(e): obéissance et comportement',
        },
    },

    it: {
        professionDesc: {
            nail_master: 'Onicotecnica specializzata in manicure, pedicure e nail art',
            hairdresser: 'Parrucchiere/a: tagli, colore e trattamenti',
            barber: 'Barbiere specializzato in grooming maschile e tagli',
            makeup_artist: 'Make-up artist per eventi, matrimoni e servizi fotografici',
            brow_lash: 'Specialista sopracciglia e ciglia: forma, extension, laminazione',
            cosmetologist: 'Estetista: trattamenti viso e procedure cosmetiche',
            massage_therapist: 'Massaggiatore/trice qualificato/a: terapeutico e rilassante',
            permanent_makeup: 'Specialista trucco permanente: sopracciglia, labbra, eyeliner',
            hair_extensions: 'Specialista extension capelli: applicazione e correzione',
            laser_hair_removal: 'Specialista epilazione laser',
            personal_trainer: 'Personal trainer certificato/a',
            online_fitness: 'Coach fitness online',
            yoga_instructor: 'Insegnante di yoga per sessioni private',
            pilates_instructor: 'Istruttore/trice di pilates e conditioning',
            psychologist: 'Psicologo/a abilitato/a: consulenza e terapia',
            psychotherapist: 'Psicoterapeuta in libera professione',
            speech_therapist: 'Logopedista',
            rehabilitation: 'Specialista in riabilitazione: recupero e terapia fisica',
            osteopath: 'Osteopata: terapia manuale e approccio olistico',
            physiotherapist: 'Fisioterapista: movimento e riabilitazione',
            coach: 'Life o business coach: sviluppo personale',
            nutritionist: 'Nutrizionista: piani alimentari e consulenza salute',
            private_lawyer: 'Avvocato/a in libera professione: consulenze e documenti',
            attorney: 'Avvocato/a: rappresentanza e difesa legale',
            tax_consultant: 'Consulente fiscale: pianificazione e conformità',
            accountant: 'Contabile: contabilità e report finanziari',
            financial_advisor: 'Consulente finanziario/a: investimenti e pianificazione',
            mortgage_advisor: 'Consulente mutui: finanziamento immobiliare',
            photographer: 'Fotografo/a professionista',
            videographer: 'Videomaker: riprese, montaggio, produzione',
            event_host: 'Presentatore/trice e host di eventi',
            dj: 'DJ: musica e intrattenimento per eventi',
            tutor: 'Tutor privato/a: materie scolastiche',
            language_teacher: 'Insegnante di lingue: lingue straniere',
            music_teacher: 'Insegnante di musica: strumenti e canto',
            child_psychologist: 'Psicologo/a infantile: sviluppo e comportamento',
            school_prep: 'Educatore/trice: preparazione alla scuola',
            groomer: 'Toelettatore/trice: bagno, styling e cura',
            dogsitter: 'Dogsitter: cura e pensione',
            dog_walker: 'Dog walker: passeggiate programmate ed esercizio',
            dog_trainer: 'Addestratore/trice cinofilo/a: obbedienza e comportamento',
        },
    },

    pt: {
        professionDesc: {
            nail_master: 'Profissional de unhas especializado em manicure, pedicure e nail art',
            hairdresser: 'Cabeleireiro/a: cortes, coloração e tratamentos',
            barber: 'Barbeiro especializado em cortes masculinos e barba',
            makeup_artist: 'Maquiador/a para eventos, casamentos e ensaios fotográficos',
            brow_lash: 'Especialista em sobrancelhas e cílios: design, extensão e laminação',
            cosmetologist: 'Esteticista: cuidados com a pele, faciais e procedimentos косметológicos',
            massage_therapist: 'Massoterapeuta qualificado/a: terapêutico e relaxante',
            permanent_makeup: 'Especialista em maquiagem permanente: sobrancelhas, lábios e delineador',
            hair_extensions: 'Especialista em alongamento capilar: aplicação e correção',
            laser_hair_removal: 'Especialista em depilação a laser',
            personal_trainer: 'Personal trainer certificado/a',
            online_fitness: 'Coach de fitness online',
            yoga_instructor: 'Instrutor/a de yoga para sessões privadas',
            pilates_instructor: 'Instrutor/a de pilates e condicionamento',
            psychologist: 'Psicólogo/a licenciado/a: aconselhamento e terapia',
            psychotherapist: 'Psicoterapeuta em consultório particular',
            speech_therapist: 'Fonoaudiólogo/a',
            rehabilitation: 'Especialista em reabilitação: recuperação e terapia física',
            osteopath: 'Osteopata: terapia manual e abordagem holística',
            physiotherapist: 'Fisioterapeuta: movimento e reabilitação',
            coach: 'Coach de vida ou negócios: desenvolvimento pessoal',
            nutritionist: 'Nutricionista: planos alimentares e consultoria em saúde',
            private_lawyer: 'Advogado/a autônomo/a: consultas e documentos',
            attorney: 'Advogado/a: representação e defesa',
            tax_consultant: 'Consultor/a fiscal: planejamento e conformidade',
            accountant: 'Contador/a: contabilidade e relatórios financeiros',
            financial_advisor: 'Consultor/a financeiro/a: investimentos e planejamento',
            mortgage_advisor: 'Consultor/a de hipoteca: financiamento imobiliário',
            photographer: 'Fotógrafo/a profissional',
            videographer: 'Videomaker: filmagem, edição e produção',
            event_host: 'Apresentador/a e mestre de cerimônias',
            dj: 'DJ: música e entretenimento para eventos',
            tutor: 'Professor/a particular: matérias acadêmicas',
            language_teacher: 'Professor/a de idiomas: línguas estrangeiras',
            music_teacher: 'Professor/a de música: instrumentos e canto',
            child_psychologist: 'Psicólogo/a infantil: desenvolvimento e comportamento',
            school_prep: 'Especialista em educação infantil: preparação escolar',
            groomer: 'Tosador/a: banho, tosa e cuidados',
            dogsitter: 'Cuidador/a de cães: cuidado e hospedagem',
            dog_walker: 'Passeador/a de cães: passeios programados e exercício',
            dog_trainer: 'Adestrador/a: obediência e comportamento',
        },
    },

    cs: {
        professionDesc: {
            nail_master: 'Nehtová designérka/designér: manikúra, pedikúra a nail art',
            hairdresser: 'Kadeřník/kadeřnice: střihy, barvení a péče',
            barber: 'Barber: pánské střihy a úprava vousů',
            makeup_artist: 'Vizážista/vizážistka pro akce, svatby a focení',
            brow_lash: 'Specialista/specialistka na obočí a řasy: tvarování, prodlužování, laminace',
            cosmetologist: 'Kosmetička/kosmetička: pleťová péče a kosmetické procedury',
            massage_therapist: 'Masér/masérka s kvalifikací: terapeutická a relaxační masáž',
            permanent_makeup: 'Specialista/specialistka na permanentní make-up: obočí, rty, linky',
            hair_extensions: 'Specialista/specialistka na prodlužování vlasů: aplikace a korekce',
            laser_hair_removal: 'Specialista/specialistka na laserovou epilaci',
            personal_trainer: 'Certifikovaný osobní trenér/ka',
            online_fitness: 'Online fitness kouč/trenér',
            yoga_instructor: 'Instruktor/ka jógy pro soukromé lekce',
            pilates_instructor: 'Instruktor/ka pilates a kondičního cvičení',
            psychologist: 'Psycholog/psycholožka: poradenství a terapie',
            psychotherapist: 'Psychoterapeut/psychoterapeutka v soukromé praxi',
            speech_therapist: 'Logoped/logopedka',
            rehabilitation: 'Rehabilitační specialista/specialistka: rekonvalescence a fyzioterapie',
            osteopath: 'Osteopat/osteopatka: manuální a holistická terapie',
            physiotherapist: 'Fyzioterapeut/ka: pohyb a rehabilitace',
            coach: 'Life nebo business kouč: osobní rozvoj',
            nutritionist: 'Nutriční poradce/poradkyně: jídelníček a zdravotní konzultace',
            private_lawyer: 'Soukromý právník/právnička: konzultace a dokumenty',
            attorney: 'Advokát/advokátka: právní zastoupení',
            tax_consultant: 'Daňový poradce/poradkyně: plánování a compliance',
            accountant: 'Účetní: účetnictví a finanční výkazy',
            financial_advisor: 'Finanční poradce/poradkyně: investice a plánování',
            mortgage_advisor: 'Hypoteční poradce/poradkyně: financování bydlení',
            photographer: 'Profesionální fotograf/fotografka',
            videographer: 'Videograf/videografka: natáčení, střih, produkce',
            event_host: 'Moderátor/ka a hostitel/ka akcí',
            dj: 'DJ: hudba a zábava na akcích',
            tutor: 'Soukromý učitel/učitelka: školní předměty',
            language_teacher: 'Učitel/učitelka jazyků: výuka cizích jazyků',
            music_teacher: 'Učitel/učitelka hudby: nástroje a zpěv',
            child_psychologist: 'Dětský psycholog/psycholožka: vývoj a chování',
            school_prep: 'Specialista/specialistka předškolní výchovy: příprava do školy',
            groomer: 'Groomer: koupání, úprava srsti a péče',
            dogsitter: 'Hlídač/ka psů: péče a ubytování',
            dog_walker: 'Venčitel/ka psů: pravidelné procházky a pohyb',
            dog_trainer: 'Trenér/ka psů: poslušnost a chování',
        },
    },
}